import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../../../services/apiService';
import { mapState } from 'vuex';
import { isNullOrEmpty } from '../../../../../utils/vuex';
import debounce from 'lodash/debounce';
import sortBy from 'lodash/sortBy';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreDtwinStateVirtualDeviceEdit',
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    tenantId: {
      type: Number,
      required: true
    },
    // is this an 'edit', 'create', or mass-variable- 'import'?
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    },
    dataSources: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      // the current result-set for the autocomplete device search
      virtualDevices: [],
      loadingDevices: false,
      virtualDeviceSearch: '',
      selectedVirtualDevice: null,
      // the key to find the found array of devices in `virtualDeviceFetch`
      virtualDeviceFetchVariable: 'virtualDevices',
      virtualDeviceVariableHeaders: [{
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.key'),
        value: 'key',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.value'),
        value: 'value.value',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.lastUpdate'),
        value: 'milliseconds_ago',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.unit'),
        value: 'properties.unit',
        align: 'left'
      }],
      virtualDeviceVariableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [20, 50, {
          text: this.$i18n_t('Common.all'),
          value: -1
        }]
      },
      // the retrieved states for the selected device
      virtualDeviceStates: null,
      selectedVirtualDeviceState: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    hasManageAllPermissions: function hasManageAllPermissions() {
      return this.permissions['all.manage'];
    },
    formIsValid: function formIsValid() {
      return !isNullOrEmpty(this.selectedVirtualDevice) && !isNullOrEmpty(this.selectedVirtualDeviceState) && this.selectedVirtualDeviceState.length > 0;
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    virtualDeviceSourceName: function virtualDeviceSourceName() {
      return (this.dataSources.find(function (ds) {
        return ds.type === 'virtual-device';
      }) || {}).name || this.$i18n_t('DigitalTwin.VirtualDevice.title');
    }
  }),
  watch: {
    virtualDeviceSearch: function virtualDeviceSearch(val) {
      if (!val || val.length < 1) {
        // if search value is empty or less than two characters do not start a search
        // but treat the old search as invalid as a new search is as about to happen
        // in this state no results will be shown in the auto-complete dropdown
        // because we set `virtualDevices` to an array with only `selectedVirtualDevice`
        // which will not show up because auto-completes `hide-selected` is true
        // while `loadingDevices` is true or the search is empty or less than two characters
        this.virtualDevices = [this.selectedVirtualDevice].filter(function (d) {
          return d;
        });
        return;
      } // do not trigger the device-search (again) after the item has been selected
      // that would clear the variable-set


      if (!this.selectedVirtualDevice || !this.selectedVirtualDevice.title || val !== this.selectedVirtualDevice.title) {
        // set loadingDevices to true as early as the debounced fetchDevices will be called
        // to not delay the loading state when settings it from the debounced method
        this.loadingDevices = true;
        this.fetchDevices();
      }
    },
    selectedVirtualDevice: function selectedVirtualDevice(val) {
      if (val !== null) {
        this.fetchStates();
      }

      this.emitSelection();
    },
    selectedVirtualDeviceState: function selectedVirtualDeviceState() {
      this.emitSelection();
    }
  },
  created: function created() {
    var _this2 = this;

    if (this.mode !== 'create' && this.mode !== 'import' && get(this.lclModel, 'properties.binding.options.virtualDevice.id')) {
      ApiService.virtualDeviceGet(this, get(this.lclModel, 'properties.binding.options.virtualDevice.id'), true).then(function (res) {
        var device = res;

        if (!device || !device.id) {
          throw new Error('NIOTA_DEVICE_NOT_FOUND');
        }

        _this2.virtualDevices = device ? [device] : null;
        _this2.selectedVirtualDevice = device;
      }).catch(function (error) {
        console.error(get(error, 'response.status'));

        if (get(error, 'response.status') === 403) {
          // user has no permission to read the device
          // probably some other user linked it, and this user cannot read it
          // so emit the no-permission event here to trigger the edit-dialog to be closed
          _this2.$emit('no-permission', _this2.$i18n_t('DigitalTwin.DigitalTwin.states.noPermissionError'));

          return;
        }

        console.error(error);
        var errorMessage = get(error, 'response.data.message', error.message);
        var errorOutput = _this2.$i18n_te("Error.".concat(errorMessage)) ? _this2.$i18n_t("Error.".concat(errorMessage)) : _this2.$i18n_t(errorMessage);

        _this2.$snack(errorOutput, 'error');

        _this2.virtualDevices = null;
        _this2.selectedVirtualDevice = null;
      }).finally(function () {
        _this2.loading = false;
      });
      this.selectedVirtualDeviceState = [{
        id: get(this.lclModel, 'properties.binding.options.virtualDevice.stateId')
      }];
    }
  },
  mounted: function mounted() {
    this.lclModel.properties.binding.options = _objectSpread(_objectSpread({}, this.lclModel.properties.binding.options), {}, {
      virtualDevice: _objectSpread({}, this.lclModel.properties.binding.options.virtualDevice)
    });
  },
  methods: {
    get: get,
    emitSelection: function emitSelection() {
      this.$emit('bridge-binding-changed', {
        identifier: get(this.selectedVirtualDevice, 'id'),
        valueType: get(this.selectedVirtualDeviceState, '[0].properties.valueType'),
        variable: get(this.selectedVirtualDeviceState, '[0].key'),
        value: get(this.selectedVirtualDeviceState, '[0].value.value')
      });
    },
    // put the request in separate function, in case some components needs to overwrite it with own logic
    // e.g. in the heat-monitoring module where a custom list of "meters" with custom search-filter needs to be requested
    fetchRequest: function fetchRequest() {
      return ApiService.virtualDeviceFetch(this, null, null, null, ['bare'], null, 0, 50, [{
        or: [{
          variable: 'title',
          search: this.virtualDeviceSearch
        }, {
          variable: 'id',
          search: this.virtualDeviceSearch
        }, {
          variable: 'deviceId',
          search: this.virtualDeviceSearch
        }]
      }]);
    },
    fetchDevices: debounce(function () {
      var _this3 = this;

      this.loadingDevices = true;
      this.fetchRequest().then(function (res) {
        _this3.virtualDevices = get(res, _this3.virtualDeviceFetchVariable) || [];
      }).catch(function (error) {
        console.error(error);
        var errorMessage = get(error, 'response.data.message', error.message);
        var errorOutput = _this3.$i18n_te("Error.".concat(errorMessage)) ? _this3.$i18n_t("Error.".concat(errorMessage)) : _this3.$i18n_t(errorMessage);

        _this3.$snack(errorOutput, 'error'); // logException(error);


        _this3.virtualDevices = [];
      }).finally(function () {
        _this3.loadingDevices = false;
      });
    }, 250),
    fetchStates: function fetchStates() {
      var _this4 = this;

      this.virtualDeviceStates = null;

      if (!get(this, 'selectedVirtualDevice.id')) {
        return;
      }

      ApiService.digitalTwinFetchStates(this, this.selectedVirtualDevice.id).then(function (states) {
        _this4.virtualDeviceStates = states.map(function (state) {
          if (state.value.time) {
            state['milliseconds_ago'] = new Date() - new Date(state.value.time);
            state['time_ago'] = state['milliseconds_ago'];
            var units = ['seconds', 'minutes', 'hours', 'days', 'months'];
            var conversion = [1000, 60, 60, 24, 30];
            var selectedUnit = 0;

            while (state['time_ago'] >= conversion[selectedUnit] && selectedUnit < conversion.length) {
              state['time_ago'] = Math.floor(state['time_ago'] / conversion[selectedUnit]);
              selectedUnit++;
            }

            selectedUnit--;

            if (selectedUnit >= 0) {
              state['time_ago'] = "".concat(state['time_ago'], " ").concat(units[selectedUnit]);
            }
          }

          return state;
        });
        _this4.virtualDeviceStates = sortBy(_this4.virtualDeviceStates, 'properties.orderIdx', 'createdAt');
        _this4.selectedVirtualDeviceState = cloneDeep(_this4.selectedVirtualDeviceState);
      }).catch(function (error) {
        console.error(error);
        var errorMessage = get(error, 'response.data.message', error.message);
        var errorOutput = _this4.$i18n_te("Error.".concat(errorMessage)) ? _this4.$i18n_t("Error.".concat(errorMessage)) : _this4.$i18n_t(errorMessage);

        _this4.$snack(errorOutput, 'error'); // logException(error);


        _this4.virtualDeviceStates = [];
      });
    },
    saveState: function saveState() {
      this.lclModel.properties.binding.options.configId = undefined;
      this.lclModel.properties.binding.options.virtualDevice = {
        id: get(this.selectedVirtualDevice, 'id'),
        stateId: get(this.selectedVirtualDeviceState, '[0].id')
      };
    }
  }
};